import React from 'react'
import Navbar from '../Navbar'
import './errorpage.css'
import errorimg from "../../../assets/images/404.png"
import MyButton1 from '../../../component/CustomComponents/MyButton1'
import { useNavigate } from 'react-router-dom'
function Error404() {
    const navigate = useNavigate()
      const backtoHome = () => {
      navigate("/");
    };
  return (
    <>
    <Navbar />
    <div className='pagebody'>
        <div>
               <a
          href="https://storyset.com/online"
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: "default" }}
        >
          <img
            src={errorimg}
            alt="404 Page Not Found"
            style={{ width: "350px", height: "300px" }}
          />
        </a>
        </div>
        <div>
            <h1>Oops!</h1>
            <p className='errortext'>We couldn't find that page.</p>
            <MyButton1 title="Back To HomePage" method={backtoHome}/>
        </div>
        
    </div>
    </>
  )
}

export default Error404